export function httpGet(url, onSucess, onFailed, cache) {
    fetch(process.env.REACT_APP_API_URL + url, { method: 'GET' })
        .then(async (response) => {
            let resp = await response.json();
            if (response.status === 200) {
                onSucess(resp.data, resp.message);
            } else {
                throw resp;
            }
        }).catch((error) => {
            if (error.type === undefined) {
                onFailed({
                    type: 'GenericException',
                    message: error.message,
                });
            } else {
                onFailed(error);
            }
        });
}

export function httpPost(url, body, onSucess, onFailed, cache) {
    fetch(process.env.REACT_APP_API_URL + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async (response) => {
        let resp = await response.json();
        if (response.status === 200) {
            onSucess(resp.data, resp.message);
        } else {
            throw resp;
        }
    }).catch((error) => {
        if (error.type === undefined) {
            onFailed({
                type: 'GenericException',
                message: error.message,
            });
        } else {
            onFailed(error);
        }
    });
}

export function httpDelete(url, onSucess, onFailed) {
    fetch(process.env.REACT_APP_API_URL + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ delete: true })
    }).then(async (response) => {
        let resp = await response.json();
        if (response.status === 200) {
            onSucess();
        } else {
            throw resp;
        }
    }).catch((error) => {
        if (error.type === undefined) {
            onFailed({
                type: 'GenericException',
                message: error.message,
            });
        } else {
            onFailed(error);
        }
    });
}